module.exports = __webpack_public_path__ + "static/img/8areaA_05.c0a084b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_05.png
// module id = 1052
// module chunks = 1